import { AdminOrganizationsQuery } from '@alice-financial/alice-sdk'
import { Box, Card, CardContent, Divider, Grid, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'

interface BrokerDashboardStatsProps {
  adminOrganization: AdminOrganizationsQuery['adminOrganizations']
}

export const BrokerDashboardStats: React.FC<BrokerDashboardStatsProps> = ({ adminOrganization }) => {
  const currentMonthName = new Date().toLocaleDateString('en-US', { month: 'long' })

  const onboardingCount = adminOrganization.totalCount - adminOrganization.launchedCount

  return (
    <Box my={3} maxWidth="md">
      <Grid container spacing={2}>
        <Grid size={6}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="body2" fontWeight="bold">
                Onboarding
              </Typography>
              <Divider sx={{ mt: 1, mb: 1.5 }} />
              <Typography variant="body2">
                <strong>{onboardingCount.toLocaleString()}</strong> clients
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={6}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="body2" fontWeight="bold">
                Launched
              </Typography>
              <Divider sx={{ mt: 1, mb: 1.5 }} />
              <Typography variant="body2">
                <strong>{adminOrganization.launchedCount.toLocaleString()}</strong> clients (
                {adminOrganization.launchedCountMtd.toLocaleString()} in {currentMonthName})
              </Typography>
              <Typography variant="body2">
                <strong>{adminOrganization.launchedEmployeeCount.toLocaleString()}</strong> employees (
                {adminOrganization.launchedEmployeeCountMtd.toLocaleString()} in {currentMonthName})
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
